import { render } from "./VersionSummaryModal.vue?vue&type=template&id=063ac78a&scoped=true"
import script from "./VersionSummaryModal.vue?vue&type=script&lang=js"
export * from "./VersionSummaryModal.vue?vue&type=script&lang=js"

import "./VersionSummaryModal.vue?vue&type=style&index=0&id=063ac78a&scoped=true&lang=css"

import exportComponent from "/var/www/matchmaker/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-063ac78a"]])

export default __exports__